import {
  apiClient,
  getStoredAuth,
  resolveApiErrorMessage,
} from './authApi';

function withAuthHeaders() {
  const { accessToken } = getStoredAuth();

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

export const salesApi = {
  async listSales(options = {}) {
    const { bustCache = false } = options;

    const response = await apiClient.get('/sales', {
      headers: {
        ...withAuthHeaders(),
        'Cache-Control': 'no-cache, no-store, max-age=0',
        Pragma: 'no-cache',
        Expires: '0',
      },
      ...(bustCache ? { params: { _t: Date.now() } } : {}),
    });

    return response.data;
  },

  async createSale(payload) {
    const response = await apiClient.post('/sales', payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async updateSale(saleId, payload) {
    const response = await apiClient.put(`/sales/${saleId}`, payload, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },

  async deleteSale(saleId) {
    const response = await apiClient.delete(`/sales/${saleId}`, {
      headers: withAuthHeaders(),
    });

    return response.data;
  },
};

export function resolveSalesApiError(error) {
  return resolveApiErrorMessage(error, 'Failed to process sales request.');
}

